import { render } from "./cart_page.vue?vue&type=template&id=3e56df74"
import script from "./cart_page.vue?vue&type=script&lang=js"
export * from "./cart_page.vue?vue&type=script&lang=js"

import "./cart_page.vue?vue&type=style&index=0&id=3e56df74&lang=css"
script.render = render

export default script